import styled from '@emotion/styled';
import RadioButton from '@components/RadioButton';
import { breakpoints, spacing } from '@naf/theme';

export const FieldWrapper = styled.div`
  margin-top: ${spacing.space4};

  @media (min-width: ${breakpoints.m}) {
    width: 544px;
  }

  width: 100%;
`;

export const RadioButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const StyledRadioButton = styled(RadioButton)`
  padding: 0;

  @media (max-width: ${breakpoints.s}) {
    width: fit-content;
    margin-right: ${spacing.space32};
  }
`;
